import axios from "axios";
import Cookies from "js-cookie";

const API_HOST = process.env.REACT_APP_APIHOSTURL;
// Create the API client
const apiClient = axios.create({
  baseURL: API_HOST,
  headers: {
    "Content-Type": "application/json",
  },
});

const setAuthorizationHeader = async () => {
  try {
    const accesstoken = Cookies.get("accesstoken");
    if (accesstoken) {
      apiClient.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${accesstoken}`;
    }
  } catch (error) {
    console.error("Failed to set authorization header:", error);
  }
};

// Call the function to set the header
setAuthorizationHeader();

export default apiClient;
